import React from "react";
import "./style-rtl.scss";
import Logo from "../../asset/image/new-logo.svg";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";

export default function Landing() {
    const { t } = useTranslation();

    return (
        <div className="landing">
            {t("greeting.label")}
            <Spinner animation="border" style={{ marginTop: 100 }} />
            <img className="logo" src={Logo} alt="" />
        </div>
    );
}
